export default __webpack_public_path__ + "static/media/MC.7dca390b.svg";